module.exports = __webpack_public_path__ + "img/c425e11.png";